.ugc-question-title-wrap {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  .question-text {
    grid-column: span 3 / span 3;
  }
  .question-button {
    grid-column: span 2 / span 2;
  }
}
